<template>
  <el-select :value="value" @change="changeAction" :disabled="disabled">
    <el-option
      v-for="option in booleanOptions"
      :label="option.label"
      :value="option.value"
      :key="`${name}${option.label}`"
    ></el-option>
  </el-select>
</template>

<script>
import { booleanOptions } from "@/utils/common";

export default {
  name: "bool-select",
  props: {
    name: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      booleanOptions,
    };
  },
  methods: {
    changeAction(newValue) {
      this.$emit("update:value", newValue);
      this.$emit("change", newValue);
    }
  },
};
</script>